import React from 'react'
import { ResponsiveContainer, PieChart as RechartsPieChart, Pie, Cell } from 'recharts'

interface DonutChartProps {
  percentage: number
  color: string
  size?: number
  displayValue?: string
}

export function DonutChart({ 
  percentage, 
  color, 
  size = 80, 
  displayValue 
}: DonutChartProps) {
  const data = [
    { name: 'completed', value: percentage },
    { name: 'remaining', value: 100 - percentage }
  ];

  return (
    <div className="relative animate-fade-in group" style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={size * 0.35}
            outerRadius={size * 0.45}
            startAngle={90}
            endAngle={450}
            paddingAngle={0}
            dataKey="value"
          >
            <Cell fill={color} className="drop-shadow-sm" />
            <Cell fill="#1f2937" />
          </Pie>
        </RechartsPieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-lg font-bold text-white font-display group-hover:scale-110 transition-transform duration-200">
          {displayValue || `${percentage}%`}
        </span>
      </div>
    </div>
  );
}